import { render, staticRenderFns } from "./FileUploadArea.vue?vue&type=template&id=9532b222&scoped=true&"
import script from "./FileUploadArea.vue?vue&type=script&lang=js&"
export * from "./FileUploadArea.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadArea.vue?vue&type=style&index=0&id=9532b222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9532b222",
  null
  
)

export default component.exports